export const CARD_TYPE = {
  ATTRACTION: 'ATTRACTION',
  TOUR: 'TOUR',
};
